export default "__VITE_ASSET__20enBIZ4__"